import { Component } from 'preact';
import PropTypes from 'prop-types';

export class Summary extends Component {
  render() {
    const {
      modelName,
      versionName,
      image,
      unitName,
      preferredDate,
      preferredTimeLabel,
      name,
      email,
      phone,
      cpf,
      homeLink,
    } = this.props;

    return (
      <section className="summary">
        <h2 className="test-drive__title">
          Sua solicitação de Test Drive foi enviada!
        </h2>
        <p className="test-drive__subtitle">
          Sua solicitação de agendamento de test drive foi enviada com sucesso.
          <br />
          <br />
          Em breve um consultor da concessionária entrará em contato para
          confirmar o agendamento.
        </p>

        <div className="summary-card">
          <h3 className="summary-card__title">Informações enviadas</h3>

          <div className="summary-card__section">
            <strong>{modelName}</strong>
            <span className="text-dark">{versionName}</span>
            {image && (
              <div className="text-center">
                <img
                  src={image}
                  alt={modelName}
                  className="summary-card__image"
                />
              </div>
            )}
          </div>

          <div className="summary-card__section">
            <strong>Unidade selecionada</strong>
            <span className="mb-3">{unitName}</span>

            <strong>Data e horário de preferência</strong>
            <span>
              {preferredDate.split('-').reverse().join('/')} -{' '}
              {preferredTimeLabel}
            </span>
          </div>

          <div className="summary-card__section">
            <strong>Dados pessoais</strong>
            <span>{name}</span>
            <span>{email}</span>
            <span>{phone}</span>
            <span>{cpf}</span>
          </div>
        </div>

        <section className="test-drive-buttons">
          <a
            className="test-drive__button test-drive__button--next"
            href={homeLink}
          >
            Ir para página inicial
          </a>
        </section>
      </section>
    );
  }
}

Summary.propTypes = {
  modelName: PropTypes.string,
  versionName: PropTypes.string,
  image: PropTypes.string,
  unitName: PropTypes.string,
  preferredDate: PropTypes.string,
  preferredTimeLabel: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  cpf: PropTypes.string,
  homeLink: PropTypes.string,
};
